import { Component } from '@angular/core';

@Component({
  selector: 'wsb-loader',
  template: `
    <mat-spinner></mat-spinner>
  `,
  standalone: false
})
export class LoaderComponent {
  constructor() {}
}
